module.exports = __webpack_public_path__ + "img/回升-lv3.739b5d9c.png";